import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";

import {
  foodMenuCategoryCreate,
  foodMenuCategoryDelete,
  foodMenuCategoryDeleteSuccess,
  foodMenuCategoryList,
  foodMenuCategoryUpdate,
  foodMenuCategoryUpdateSuccess,
  foodMenuItemCreate,
  foodMenuItemCreateSuccess,
  foodMenuItemDelete,
  foodMenuItemDeleteSuccess,
  foodMenuItemList,
  foodMenuItemUpdate,
  foodMenuItemUpdateSuccess,
  foodMenuStatusCreate,
  foodMenuStatusCreateSuccess,
  foodMenuStatusDelete,
  foodMenuStatusDeleteSuccess,
  foodMenuStatusList,
  foodMenuStatusUpdate,
  foodMenuStatusUpdateSuccess,
  foodMenuTypeCreate,
  foodMenuTypeCreateSuccess,
  foodMenuTypeDelete,
  foodMenuTypeDeleteSuccess,
  foodMenuTypeList,
  foodMenuTypeUpdate,
  foodMenuTypeUpdateSuccess,
  foodPreOrderEventStatusCreate,
  foodPreOrderEventStatusCreateSuccess,
  foodPreOrderEventStatusDelete,
  foodPreOrderEventStatusDeleteSuccess,
  foodPreOrderEventStatusList,
  foodPreOrderEventStatusUpdate,
  foodPreOrderEventStatusUpdateSuccess,
  foodPreOrderEventTypeCreate,
  foodPreOrderEventTypeCreateSuccess,
  foodPreOrderEventTypeDelete,
  foodPreOrderEventTypeDeleteSuccess,
  foodPreOrderEventTypeList,
  foodPreOrderEventTypeUpdate,
  foodPreOrderEventTypeUpdateSuccess,
  foodPreOrderSiteLocationCreate,
  foodPreOrderSiteLocationCreateSuccess,
  foodPreOrderSiteLocationDelete,
  foodPreOrderSiteLocationDeleteSuccess,
  foodPreOrderSiteLocationList,
  foodPreOrderSiteLocationUpdate,
  foodPreOrderSiteLocationUpdateSuccess,
} from "../../../../store/foodPreOederEvent/action";
import SingleCustomerSiteLocationList from "../../../Customer/single/siteLocations";
import EventMenuTemplates from "./eventMenuTemplates";
export default function EventsSettings() {
  const dispatch = useDispatch();

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [statusFlag, setStatusFlag] = useState(false);
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    // FlagActive: "0",
  });
  const Tabs = [
    {
      id: "1",
      name: "Menu Statuses", //foodMenuStatus
    },
    {
      id: "2",
      name: "Menu Types",
    },
    {
      id: "3",
      name: "Menu Items",
    },
    {
      id: "4",
      name: "Menu Category",
    },
    {
      id: "5",
      name: "Pre Order Statuses",
    },
    {
      id: "6",
      name: "Pre Order Types",
    },
    {
      id: "7",
      name: "Pre Order Locations",
    },
    {
      id: "8",
      name: "Menu Templates",
    },
  ];
  useEffect(() => {
    dispatch(foodMenuStatusList());
    dispatch(foodMenuTypeList());
    dispatch(foodMenuItemList());
    dispatch(foodMenuCategoryList());
    dispatch(foodPreOrderEventStatusList());
    dispatch(foodPreOrderEventTypeList());
    dispatch(foodPreOrderSiteLocationList());
  }, []);

  // Create Module
  const handleCreateNewStatus = () => {
    // if property editable exists remove

    if (activeTab === "1") {
      // foodMenuStatusCreate
      dispatch(foodMenuStatusCreate([createStatus]));
    }
    if (activeTab === "2") {
      //foodMenuTypeCreate
      dispatch(foodMenuTypeCreate([createStatus]));
    }
    if (activeTab === "3") {
      // foodMenuItemCreate
      dispatch(foodMenuItemCreate([createStatus]));
    }
    if (activeTab === "4") {
      //foodMenuCategoryCreate
      dispatch(foodMenuCategoryCreate([createStatus]));
    }
    if (activeTab === "5") {
      // foodPreOrderEventStatusCreate
      dispatch(foodPreOrderEventStatusCreate([createStatus]));
    }
    if (activeTab === "6") {
      //foodPreOrderEventTypeCreate
      dispatch(foodPreOrderEventTypeCreate([createStatus]));
    }
    if (activeTab === "7") {
      //foodPreOrderSiteLocationCreate
      dispatch(foodPreOrderSiteLocationCreate([createStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      FlagActive: updateItemStatus?.FlagActive,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        // foodMenuStatus

        dispatch(foodMenuStatusUpdate([updateNewStatus]));
      }
      if (activeTab === "2") {
        // foodMenuTypeUpdate
        dispatch(foodMenuTypeUpdate([updateNewStatus]));
      }
      if (activeTab === "3") {
        // foodMenuItemUpdate
        dispatch(foodMenuItemUpdate([updateNewStatus]));
      }
      if (activeTab === "4") {
        //foodMenuCategoryUpdate
        dispatch(foodMenuCategoryUpdate([updateNewStatus]));
      }
      if (activeTab === "5") {
        //foodPreOrderEventStatusUpdate
        dispatch(foodPreOrderEventStatusUpdate([updateNewStatus]));
      }
      if (activeTab === "6") {
        //foodPreOrderEventTypeUpdate
        dispatch(foodPreOrderEventTypeUpdate([updateNewStatus]));
      }
      if (activeTab === "7") {
        //foodPreOrderSiteLocationUpdate
        dispatch(foodPreOrderSiteLocationUpdate([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  // Delete Module
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //  foodMenuStatusDelete

      dispatch(foodMenuStatusDelete([deleteStatus]));
    }
    if (activeTab === "2") {
      // foodMenuTypeDelete
      dispatch(foodMenuTypeDelete([deleteStatus]));
    }
    if (activeTab === "3") {
      // foodMenuItemDelete
      dispatch(foodMenuItemDelete([deleteStatus]));
    }
    if (activeTab === "4") {
      //foodMenuCategoryDelete
      dispatch(foodMenuCategoryDelete([deleteStatus]));
    }
    if (activeTab === "5") {
      // foodPreOrderEventStatusDelete
      dispatch(foodPreOrderEventStatusDelete([deleteStatus]));
    }
    if (activeTab === "6") {
      //foodPreOrderEventTypeDelete
      dispatch(foodPreOrderEventTypeDelete([deleteStatus]));
    }
    if (activeTab === "7") {
      //foodPreOrderSiteLocationDelete
      dispatch(foodPreOrderSiteLocationDelete([deleteStatus]));
    }
  };
  const {
    foodMenuStatusListAPI,
    foodMenuStatusListLoading,
    foodMenuCategoryListAPI,
    foodMenuCategoryListLoading,
    foodMenuItemListAPI,
    foodMenuItemListLoading,
    foodPreOrderEventStatusListAPI,
    foodPreOrderEventStatusListLoading,
    foodPreOrderEventTypeListAPI,
    foodPreOrderEventTypeListLoading,
    foodMenuTypeListAPI,
    foodMenuTypeListLoading,
    foodPreOrderSiteLocationListAPI,
    foodPreOrderSiteLocationListLoading,
  } = useSelector((state) => ({
    foodMenuStatusListAPI:
      state.FoodPreOrderEventReducer.foodMenuStatusList?.foodmenustatus_list,
    foodMenuStatusListLoading:
      state.FoodPreOrderEventReducer.foodMenuStatusListLoading,
    foodMenuCategoryListAPI:
      state.FoodPreOrderEventReducer.foodMenuCategoryList
        ?.foodmenucategory_list,
    foodMenuCategoryListLoading:
      state.FoodPreOrderEventReducer.foodMenuCategoryListLoading,
    foodMenuItemListAPI:
      state.FoodPreOrderEventReducer.foodMenuItemList?.foodmenuitem_list,
    foodMenuItemListLoading:
      state.FoodPreOrderEventReducer.foodMenuItemListLoading,
    foodPreOrderEventStatusListAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventStatusList
        ?.foodpreordereventstatus_list,
    foodPreOrderEventStatusListLoading:
      state.FoodPreOrderEventReducer.foodPreOrderEventStatusListLoading,
    foodPreOrderEventTypeListAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventTypeList
        ?.foodpreordereventtype_list,
    foodPreOrderEventTypeListLoading:
      state.FoodPreOrderEventReducer.foodPreOrderEventTypeListLoading,
    foodMenuTypeListAPI:
      state.FoodPreOrderEventReducer.foodMenuTypeList?.foodmenutype_list,
    foodMenuTypeListLoading:
      state.FoodPreOrderEventReducer.foodMenuTypeListLoading,
    foodPreOrderSiteLocationListAPI:
      state.FoodPreOrderEventReducer.foodPreOrderSiteLocationList
        ?.foodpreordersitelocation_list,
    foodPreOrderSiteLocationListLoading:
      state.FoodPreOrderEventReducer.foodPreOrderSiteLocationListLoading,
  }));
  // Active Tab and Data
  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      //foodMenuStatusListAPI
      data = foodMenuStatusListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "2") {
      //foodMenuTypeListAPI
      data = foodMenuTypeListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "3") {
      //foodMenuItemListAPI
      data = foodMenuItemListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "4") {
      //foodMenuCategoryListAPI
      data = foodMenuCategoryListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "5") {
      //foodPreOrderEventStatusListAPI
      data = foodPreOrderEventStatusListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "6") {
      //foodPreOrderEventTypeListAPI
      data = foodPreOrderEventTypeListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "7") {
      //foodPreOrderSiteLocationListAPI
      data = foodPreOrderSiteLocationListAPI?.sort((a, b) => b.Id - a.Id);
    }

    setStatusList(data);
  }, [
    foodMenuStatusListAPI,
    foodMenuTypeListAPI,
    foodMenuItemListAPI,
    foodMenuCategoryListAPI,
    foodPreOrderEventStatusListAPI,
    foodPreOrderEventTypeListAPI,
    foodPreOrderSiteLocationListAPI,
    activeTab,
  ]);

  const [deleteModal, setDeleteModal] = useState(false);

  const {
    foodMenuStatusCreateAPI,
    foodMenuStatusUpdateAPI,
    foodMenuStatusDeleteAPI,
    foodMenuCategoryCreateAPI,
    foodMenuCategoryUpdateAPI,
    foodMenuCategoryDeleteAPI,
    foodMenuItemCreateAPI,
    foodMenuItemUpdateAPI,
    foodMenuItemDeleteAPI,
    foodPreOrderEventStatusCreateAPI,
    foodPreOrderEventStatusUpdateAPI,
    foodPreOrderEventStatusDeleteAPI,
    foodPreOrderEventTypeCreateAPI,
    foodPreOrderEventTypeUpdateAPI,
    foodPreOrderEventTypeDeleteAPI,
    foodMenuTypeCreateAPI,
    foodMenuTypeUpdateAPI,
    foodMenuTypeDeleteAPI,
  } = useSelector((state) => ({
    foodMenuStatusCreateAPI:
      state.FoodPreOrderEventReducer.foodMenuStatusCreate,
    foodMenuStatusUpdateAPI:
      state.FoodPreOrderEventReducer.foodMenuStatusUpdate,
    foodMenuStatusDeleteAPI:
      state.FoodPreOrderEventReducer.foodMenuStatusDelete,
    foodMenuCategoryCreateAPI:
      state.FoodPreOrderEventReducer.foodMenuCategoryCreate,
    foodMenuCategoryUpdateAPI:
      state.FoodPreOrderEventReducer.foodMenuCategoryUpdate,
    foodMenuCategoryDeleteAPI:
      state.FoodPreOrderEventReducer.foodMenuCategoryDelete,
    foodMenuItemCreateAPI: state.FoodPreOrderEventReducer.foodMenuItemCreate,
    foodMenuItemUpdateAPI: state.FoodPreOrderEventReducer.foodMenuItemUpdate,
    foodMenuItemDeleteAPI: state.FoodPreOrderEventReducer.foodMenuItemDelete,
    foodPreOrderEventStatusCreateAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventStatusCreate,
    foodPreOrderEventStatusUpdateAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventStatusUpdate,
    foodPreOrderEventStatusDeleteAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventStatusDelete,
    foodPreOrderEventTypeCreateAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventTypeCreate,
    foodPreOrderEventTypeUpdateAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventTypeUpdate,
    foodPreOrderEventTypeDeleteAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventTypeDelete,
    foodMenuTypeCreateAPI: state.FoodPreOrderEventReducer.foodMenuTypeCreate,
    foodMenuTypeUpdateAPI: state.FoodPreOrderEventReducer.foodMenuTypeUpdate,
    foodMenuTypeDeleteAPI: state.FoodPreOrderEventReducer.foodMenuTypeDelete,
  }));

  // CREATE UPDATE DELETE effects

  //foodMenuStatusCreateAPI
  useEffect(() => {
    if (isEmpty(foodMenuStatusCreateAPI)) return;
    if (foodMenuStatusCreateAPI?.status === 200) {
      dispatch(foodMenuStatusList());
      toast.success(foodMenuStatusCreateAPI?.message);
    } else {
      toast.error(foodMenuStatusCreateAPI?.message);
    }
    dispatch(foodMenuStatusCreateSuccess([]));
  }, [foodMenuStatusCreateAPI]);

  //foodMenuStatusUpdateAPI
  useEffect(() => {
    if (isEmpty(foodMenuStatusUpdateAPI)) return;
    if (foodMenuStatusUpdateAPI?.status === 200) {
      dispatch(foodMenuStatusList());
      toast.success(foodMenuStatusUpdateAPI?.message);
    } else {
      toast.error(foodMenuStatusUpdateAPI?.message);
    }
    dispatch(foodMenuStatusUpdateSuccess([]));
  }, [foodMenuStatusUpdateAPI]);

  //foodMenuStatusDeleteAPI
  useEffect(() => {
    if (isEmpty(foodMenuStatusDeleteAPI)) return;
    if (foodMenuStatusDeleteAPI?.status === 200) {
      dispatch(foodMenuStatusList());
      toast.success(foodMenuStatusDeleteAPI?.message);
      setDeleteModal(false);
    } else {
      toast.error(foodMenuStatusDeleteAPI?.message);
    }
    dispatch(foodMenuStatusDeleteSuccess([]));
  }, [foodMenuStatusDeleteAPI]);

  //foodMenuCategoryCreateAPI
  useEffect(() => {
    if (isEmpty(foodMenuCategoryCreateAPI)) return;
    if (foodMenuCategoryCreateAPI?.status === 200) {
      dispatch(foodMenuCategoryList());
      toast.success(foodMenuCategoryCreateAPI?.message);
    } else {
      toast.error(foodMenuCategoryCreateAPI?.message);
    }
    dispatch(foodMenuStatusCreateSuccess([]));
  }, [foodMenuCategoryCreateAPI]);

  //foodMenuCategoryUpdateAPI
  useEffect(() => {
    if (isEmpty(foodMenuCategoryUpdateAPI)) return;
    if (foodMenuCategoryUpdateAPI?.status === 200) {
      dispatch(foodMenuCategoryList());
      toast.success(foodMenuCategoryUpdateAPI?.message);
    } else {
      toast.error(foodMenuCategoryUpdateAPI?.message);
    }
    dispatch(foodMenuCategoryUpdateSuccess([]));
  }, [foodMenuCategoryUpdateAPI]);

  //foodMenuCategoryDeleteAPI
  useEffect(() => {
    if (isEmpty(foodMenuCategoryDeleteAPI)) return;
    if (foodMenuCategoryDeleteAPI?.status === 200) {
      dispatch(foodMenuCategoryList());
      toast.success(foodMenuCategoryDeleteAPI?.message);
      setDeleteModal(false);
    } else {
      toast.error(foodMenuCategoryDeleteAPI?.message);
    }
    dispatch(foodMenuCategoryDeleteSuccess([]));
  }, [foodMenuCategoryDeleteAPI]);

  //foodMenuItemCreateAPI
  useEffect(() => {
    if (isEmpty(foodMenuItemCreateAPI)) return;
    if (foodMenuItemCreateAPI?.status === 200) {
      dispatch(foodMenuItemList());
      toast.success(foodMenuItemCreateAPI?.message);
    } else {
      toast.error(foodMenuItemCreateAPI?.message);
    }
    dispatch(foodMenuItemCreateSuccess([]));
  }, [foodMenuItemCreateAPI]);

  //foodMenuItemUpdateAPI
  useEffect(() => {
    if (isEmpty(foodMenuItemUpdateAPI)) return;
    if (foodMenuItemUpdateAPI?.status === 200) {
      dispatch(foodMenuItemList());
      toast.success(foodMenuItemUpdateAPI?.message);
    } else {
      toast.error(foodMenuItemUpdateAPI?.message);
    }
    dispatch(foodMenuItemUpdateSuccess([]));
  }, [foodMenuItemUpdateAPI]);

  //foodMenuItemDeleteAPI
  useEffect(() => {
    if (isEmpty(foodMenuItemDeleteAPI)) return;
    if (foodMenuItemDeleteAPI?.status === 200) {
      dispatch(foodMenuItemList());
      toast.success(foodMenuItemDeleteAPI?.message);
      setDeleteModal(false);
    } else {
      toast.error(foodMenuItemDeleteAPI?.message);
    }
    dispatch(foodMenuItemDeleteSuccess([]));
  }, [foodMenuItemDeleteAPI]);

  //foodPreOrderEventStatusCreateAPI
  useEffect(() => {
    if (isEmpty(foodPreOrderEventStatusCreateAPI)) return;
    if (foodPreOrderEventStatusCreateAPI?.status === 200) {
      dispatch(foodPreOrderEventStatusList());
      toast.success(foodPreOrderEventStatusCreateAPI?.message);
    } else {
      toast.error(foodPreOrderEventStatusCreateAPI?.message);
    }
    dispatch(foodPreOrderEventStatusCreateSuccess([]));
  }, [foodPreOrderEventStatusCreateAPI]);

  //foodPreOrderEventStatusUpdateAPI
  useEffect(() => {
    if (isEmpty(foodPreOrderEventStatusUpdateAPI)) return;
    if (foodPreOrderEventStatusUpdateAPI?.status === 200) {
      dispatch(foodPreOrderEventStatusList());
      toast.success(foodPreOrderEventStatusUpdateAPI?.message);
    } else {
      toast.error(foodPreOrderEventStatusUpdateAPI?.message);
    }
    dispatch(foodPreOrderEventStatusUpdateSuccess([]));
  }, [foodPreOrderEventStatusUpdateAPI]);

  //foodPreOrderEventStatusDeleteAPI
  useEffect(() => {
    if (isEmpty(foodPreOrderEventStatusDeleteAPI)) return;
    if (foodPreOrderEventStatusDeleteAPI?.status === 200) {
      dispatch(foodPreOrderEventStatusList());
      toast.success(foodPreOrderEventStatusDeleteAPI?.message);
      setDeleteModal(false);
    } else {
      toast.error(foodPreOrderEventStatusDeleteAPI?.message);
    }
    dispatch(foodPreOrderEventStatusDeleteSuccess([]));
  }, [foodPreOrderEventStatusDeleteAPI]);

  //foodPreOrderEventTypeCreateAPI
  useEffect(() => {
    if (isEmpty(foodPreOrderEventTypeCreateAPI)) return;
    if (foodPreOrderEventTypeCreateAPI?.status === 200) {
      dispatch(foodPreOrderEventTypeList());
      toast.success(foodPreOrderEventTypeCreateAPI?.message);
    } else {
      toast.error(foodPreOrderEventTypeCreateAPI?.message);
    }
    dispatch(foodPreOrderEventTypeCreateSuccess([]));
  }, [foodPreOrderEventTypeCreateAPI]);

  //foodPreOrderEventTypeUpdateAPI
  useEffect(() => {
    if (isEmpty(foodPreOrderEventTypeUpdateAPI)) return;
    if (foodPreOrderEventTypeUpdateAPI?.status === 200) {
      dispatch(foodPreOrderEventTypeList());
      toast.success(foodPreOrderEventTypeUpdateAPI?.message);
    } else {
      toast.error(foodPreOrderEventTypeUpdateAPI?.message);
    }
    dispatch(foodPreOrderEventTypeUpdateSuccess([]));
  }, [foodPreOrderEventTypeUpdateAPI]);

  //foodPreOrderEventTypeDeleteAPI
  useEffect(() => {
    if (isEmpty(foodPreOrderEventTypeDeleteAPI)) return;
    if (foodPreOrderEventTypeDeleteAPI?.status === 200) {
      dispatch(foodPreOrderEventTypeList());
      toast.success(foodPreOrderEventTypeDeleteAPI?.message);
      setDeleteModal(false);
    } else {
      toast.error(foodPreOrderEventTypeDeleteAPI?.message);
    }
    dispatch(foodPreOrderEventTypeDeleteSuccess([]));
  }, [foodPreOrderEventTypeDeleteAPI]);

  //foodMenuTypeCreateAPI
  useEffect(() => {
    if (isEmpty(foodMenuTypeCreateAPI)) return;
    if (foodMenuTypeCreateAPI?.status === 200) {
      dispatch(foodMenuTypeList());
      toast.success(foodMenuTypeCreateAPI?.message);
    } else {
      toast.error(foodMenuTypeCreateAPI?.message);
    }
    dispatch(foodMenuTypeCreateSuccess([]));
  }, [foodMenuTypeCreateAPI]);

  //foodMenuTypeUpdateAPI
  useEffect(() => {
    if (isEmpty(foodMenuTypeUpdateAPI)) return;
    if (foodMenuTypeUpdateAPI?.status === 200) {
      dispatch(foodMenuTypeList());
      toast.success(foodMenuTypeUpdateAPI?.message);
    } else {
      toast.error(foodMenuTypeUpdateAPI?.message);
    }
    dispatch(foodMenuTypeUpdateSuccess([]));
  }, [foodMenuTypeUpdateAPI]);

  //foodMenuTypeDeleteAPI
  useEffect(() => {
    if (isEmpty(foodMenuTypeDeleteAPI)) return;
    if (foodMenuTypeDeleteAPI?.status === 200) {
      dispatch(foodMenuTypeList());
      toast.success(foodMenuTypeDeleteAPI?.message);
      setDeleteModal(false);
    } else {
      toast.error(foodMenuTypeDeleteAPI?.message);
    }
    dispatch(foodMenuTypeDeleteSuccess([]));
  }, [foodMenuTypeDeleteAPI]);

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteStatus}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
      />
      <SettingsPanel
        title="Food Preorder Settings"
        description="Menu statuses, types, items and categories plus pre-order settings."
        tabs={Tabs.filter((item) => item.id !== "8").map((item) => ({
          value: item.id,
          label: item.name,
        }))}
        value={activeTab}
        onChange={setActiveTab}
        actions={
          <a
            href="/event-pre-order-menu"
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary"
          >
            <i className="fa-solid fa-arrow-up-right-from-square me-1"></i>
            <span className="d-sm-inline-block">Menu Templates</span>
          </a>
        }
      >
        {
          // tab between 1 and 6
          Number(activeTab) >= 1 && Number(activeTab) <= 6 && (
            <StatusViewEditComponent
              statusList={statusList}
              setStatusList={setStatusList}
              createStatus={createStatus}
              setCreateStatus={setCreateStatus}
              handleCreateNewStatus={handleCreateNewStatus}
              setDeleteStatus={setDeleteStatus}
              setDeleteModal={setDeleteModal}
              setUpdateItemStatus={setUpdateItemStatus}
              statusFlag={statusFlag}
            />
          )
        }
        {activeTab === "7" && (
          <div>
            <SingleCustomerSiteLocationList
              siteLocationData={statusList}
              page={"eventPreOrderLocations"}
            />
          </div>
        )}
        {activeTab === "8" && (
          <div>
            <hr />
            <EventMenuTemplates page={"eventMenuTemplates"} />
          </div>
        )}
      </SettingsPanel>
    </>
  );
}
